{
  "release": "1.7.0",
  "commit": "5d533800",
  "date": "2026-09-30T09:27:53Z"
}
